import styled from 'styled-components';
import { popoverShadow } from '../../themes/shadows';

export const Box = styled.div`
  background-color: ${(props) => props.theme.colors.card};
  box-shadow: ${popoverShadow};
  border-radius: 10px;
  width: 220px;
  justify-content: center;
  display: flex;
  flex-direction: column;
  padding: 10px;

  img {
    width: 70px;
    margin: 0 auto;
    padding-bottom: 10px;
  }
`;

export const Label = styled.p`
  font-style: normal;
  font-weight: 600;
  color: ${(props) => props.theme.colors.darkblue};
`;

export const Title = styled(Label)`
  text-align: center;
  margin-bottom: 10px;
  font-size: 16px;
  line-height: 16px;
  font-weight: bold;
`;

export const Description = styled(Label)`
  font-size: 12px;
`;
